function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "81",
  viewBox: "0 0 82 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: ".833",
  y: "6",
  width: "80.333",
  height: "31",
  rx: ".5",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#7E86A0",
  strokeLinecap: "round",
  d: "M4.833 10v7"
}), /*#__PURE__*/React.createElement("rect", {
  x: ".833",
  y: "6",
  width: "80.333",
  height: "31",
  rx: ".5",
  stroke: "#D2D6DB"
}), /*#__PURE__*/React.createElement("rect", {
  x: ".333",
  y: ".5",
  width: "25.417",
  height: "3",
  rx: "1",
  fill: "#D2D6DB"
})));